import { useRef } from 'react'
import { useEmitterService } from '~/hooks/useEmitterService'
import { AuthenticationEmitterEventType } from '~/services/EventEmitter/types'
import { newUuid } from '~/utils/common'

/**
 * Triggers a callback on logout - if utilized in a hook that is used in multiple places, ensure that the traceToken supplied is unique - this will guarantee the function is only called once.
 * @param handler
 * @param traceToken
 */
export const useOnLogout = (handler: () => void, traceToken?: string) => {
  const { subscribe } = useEmitterService()
  const default_token_appendix = useRef<string>(newUuid())
  const token = `$useOnLogout_${traceToken ?? default_token_appendix.current}`

  subscribe({
    subscriptionToken: token,
    subscription: {
      eventType: AuthenticationEmitterEventType.USER_LOGGED_OUT,
      callback: () => handler(),
    },
  })
}
